import StaticDashboardContainer from "components/StaticDashboard/shared/StaticDashboardContainer";
import UpsCardContainer from "../UpsCardContainer";
import UpsCard from "../UpsCard";
import FourLineChart from "../Charts/FourLinesChart";
import { useState, useEffect } from "react";
import { Item } from "types/common";
import { getTagData } from "api/tags";
import Ups1Data from "../config/v1ups";
import Ups2Data from "../config/v2ups";
import { UpsDataProps } from "../domain/types";
import Loader from "components/shared/Loader";
import classNames from "utilities/ClassNames";
import { fourChartsData, singleChartData } from "../Charts/config/LinesData";
import { UpsCardItem } from "../domain/types";
import UpsBlock from "../UpsBlock";
import { AiOutlineArrowLeft } from "react-icons/ai";
import UPSModal from "../UPSModal/UPSModal";

const V1UPS = ({ type }: { type: 'v1' | 'v2' }) => {

  const [randomTag, setRandomTag] = useState<Item | null>(null);
  const [mainConfig, setMainConfig] = useState<UpsDataProps[] | null>(null);
  const [selectedCard, setSelectedCard] = useState<number | null>(null);
  const [selectedUps, setSelectedUps] = useState<UpsCardItem | null>(null);
  const [showUPSModal, setShowUPSModal] = useState(false);

  const getSingleTag = async () => {
    const randomTagData = await getTagData([244]);
    setRandomTag(randomTagData.data[0]);
  };

  useEffect(() => {
    getSingleTag();
  }, []);

  useEffect(() => {
    if (type === 'v1') {
      setMainConfig(Ups1Data);
    }
    if (type === 'v2') {
      setMainConfig(Ups2Data);
    }
  }, [type]);

  const singleChartGreen = singleChartData({ color: '#2DC75C' });
  const singleChartBlue = singleChartData({ color: '#FFDC4A' });
  const singleChartYellow = singleChartData({ color: '#659DF2' });

  const getUpsItemById = (id: number): UpsCardItem | undefined => {
    for (const group of Ups1Data) {
      const found = group.cardItems.find(item => item.id === id);
      if (found) return found;
    }
    return undefined;
  };

  useEffect(() => {
    if (selectedCard) {
      const cardById = (getUpsItemById(selectedCard));
      if (cardById) {
        setSelectedUps(cardById);
      } else {
        setSelectedUps(null);
      }
    }
  }, [selectedCard]);

  return (
    <StaticDashboardContainer heading="">
      <div className="h-full w-full flex gap-2">
        <div className="w-[30%] bg-black rounded-lg">
          <div className="flex flex-col gap-4 h-full w-full p-4">
            <div className="h-max bg-dark rounded flex flex-col">
              <h3 className="w-full text-center font-bold text-xl p-2">Ups Status Overview</h3>
              <div>
                <div className="grid grid-cols-4 gap-4 px-4 font-bold text-sm 2xl:text-lg text-center">
                  <div className="bg-black rounded p-1 flex flex-col justify-beetween">
                    <p className="max-w-20 mx-auto flex items-center justify-center">UPS Installed</p>
                    <p className="text-2xl text-[#659DF2] flex items-center justify-center">153</p>
                  </div>
                  <div className="bg-black rounded p-1 grid grid-rows-2 justify-beetween">
                    <p className="max-w-20 mx-auto flex items-center justify-center">UPS Operational</p>
                    <p className="text-2xl text-[#2DC75C] flex items-center justify-center">67</p>
                  </div>
                  <div className="bg-black rounded p-1 grid grid-rows-2 justify-beetween">
                    <p className="max-w-20 mx-auto flex items-center justify-center">UPS with Warnings</p>
                    <p className="text-2xl text-[#FFDC4A] flex items-center justify-center">53</p>
                  </div>
                  <div className="bg-black rounded p-1 grid grid-rows-2 justify-beetween">
                    <p className="max-w-20 mx-auto flex items-center justify-center">UPS in fault</p>
                    <p className="text-2xl text-red flex items-center justify-center">67</p>
                  </div>
                </div>
              </div>
              {randomTag && <div className="flex-1 flex items-start justify-end p-4">
                <FourLineChart data={fourChartsData} />
              </div>}
            </div>
            <div className="flex-1 bg-dark rounded overflow-hidden">
              <h3 className="w-full text-center font-bold text-xl p-2">Alarms:</h3>

              {/* ✅ wrap the table in a div with fixed max-height & overflow */}
              <div className="max-h-32 xl-2xl:max-h-48 2xl:max-h-[235px] overflow-y-auto">
                <table className="w-full">
                  <thead>
                    <tr>
                      <th className="text-start">Source</th>
                      <th className="text-center">Time</th>
                      <th className="text-end">Message</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.from({ length: 5 }).map((_, i) => (
                      <tr key={i}>
                        <td className="text-start p-0 px-1.5 2xl:p-1.5">SDAIA</td>
                        <td className="text-center p-0 2xl:p-1.5">12:00</td>
                        <td className="text-end p-0 2xl:p-1.5 pr-2">Alarm {i + 1}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="w-[70%] bg-black p-4 rounded-lg">
          {
            !selectedCard && <div className="grid grid-cols-2 grid-rows-2 gap-4 w-full h-full">
              {mainConfig ? mainConfig.map((cardContainer, index) => {
                return (
                  <UpsCardContainer title={cardContainer.title} key={index} >
                    <div className={classNames(type === 'v2' ? "flex justify-around" : "grid-cols-3 grid", "gap-2 p-2 h-full")}>
                      {cardContainer.cardItems.map((cardItem, i) => {
                        return (
                          <div key={i} className="hover:-translate-y-1 hover:bg-[#061D2E] hover:rounded-md  hover:shadow-xl hover:border hover:border-[#65F4CD]">
                            <UpsCard item={cardItem} onClick={setSelectedCard} />
                          </div>
                        );
                      })}
                    </div>
                  </UpsCardContainer>
                );
              }
              ) : <Loader />}

            </div>
          }
          {
            selectedCard &&
            <div className="h-full w-full flex gap-4">
              <div className="flex-1">
                <div className="p-4 border border-[#134366] rounded-md h-full flex flex-col justify-between relative">
                  <div className="absolute left-4 top-4 z-50">
                    <button
                      onClick={() => setSelectedCard(null)}
                      className="flex items-center gap-1 text-white px-2 py-1 bg-[#373d7e] rounded-md hover:bg-gray-100 cursor-pointer"
                      type="button"
                    >
                      <AiOutlineArrowLeft size={20} />
                      Back
                    </button>
                  </div>
                  {selectedUps &&
                    <div className="flex flex-col h-full relative">
                      <div className="flex items-center justify-center h-1/2 pb-8 z-30">
                        <div className="h-full bg-black">
                          <UpsCard item={{ ...selectedUps, type: selectedUps.type === 'normal' ? 'dark' : selectedUps.type }} onClick={() => null} />
                        </div>
                      </div>
                      <div className="w-full flex-1 flex items-end justify-center">
                        <div className="flex gap-4 relative">
                          <div className="cursor-pointer hover:-translate-y-1 hover:bg-[#061D2E] hover:rounded-md  hover:shadow-xl hover:border-[#65F4CD]" onClick={() => setShowUPSModal(true)}>
                            <UpsBlock type="normal" />
                          </div>
                          <div className="cursor-pointer hover:-translate-y-1 hover:bg-[#061D2E] hover:rounded-md  hover:shadow-xl hover:border-[#65F4CD]" onClick={() => setShowUPSModal(true)}>
                            <UpsBlock type="warning" />
                          </div>
                          <div className="cursor-pointer hover:-translate-y-1 hover:bg-[#061D2E] hover:rounded-md  hover:shadow-xl hover:border-[#65F4CD]" onClick={() => setShowUPSModal(true)}>
                            <UpsBlock type="danger" />
                          </div>
                          <div className="absolute -top-6 left-0 w-full h-6 z-10 pointer-events-none">
                            <div className="h-full ml-16 mr-16 border-2 border-b-0 flex items-center justify-center z-10">
                              <div className="relative z-10 h-full">
                                <div className="w-[2px] bg-white h-[35vh] absolute bottom-0 z-10" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
              <div className="w-[30%] flex flex-col gap-4 border border-[#134366] bg-dark p-2 rounded-lg">
                <div className="w-full text-center font-bold text-xl p-2">{selectedUps?.title}</div>
                <div className="bg-dark/30 p-2">
                  <FourLineChart data={singleChartBlue} />
                </div>
                <div className="bg-dark/30 p-2">
                  <FourLineChart data={singleChartGreen} />
                </div>
                <div className="bg-dark/30 p-2">
                  <FourLineChart data={singleChartYellow} />
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      {showUPSModal && <UPSModal chartData={singleChartGreen} setShowModal={setShowUPSModal} />}
    </StaticDashboardContainer>
  );
};

export default V1UPS;